import NestedAboutUsComponent from '../../components/nestedAboutUsComponent';

export const NestedAboutUsPage = () => <NestedAboutUsComponent />
